import { keyframes } from '@emotion/react'
import styled from '@emotion/styled'

const spin = keyframes`
  to { transform: rotate(360deg); }
`

export const Overlay = styled('div')`
  position: fixed;
  inset: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
`

export const Spinner = styled('div')`
  width: 48px;
  height: 48px;
  border: 4px solid #cd7629;
  border-top-color: transparent;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`
